const SOLES = 'SOLES'
const DOLARES = 'DOLARES'
const EUROS = 'EUROS'
const BIMONEDA = 'BIMONEDA'

const __dictionary = {
  [SOLES]: {
    id: [SOLES],
    nombre: 'SOLES',
    signo: 'S/ .',
    nombreCompleto: 'SOLES'
  },
  [DOLARES]: {
    id: [DOLARES],
    nombre: 'DÓLARES',
    signo: 'USD',
    nombreCompleto: 'DOLARES AMERICANOS'
  },
  [EUROS]: {
    id: [EUROS],
    nombre: 'EUROS',
    signo: 'EUR',
    nombreCompleto: 'EUROS'
  }
}

const __dictionaryAuxiliar = {
  [SOLES]: {
    id: [SOLES],
    nombre: 'SOLES',
    signo: 'S/ .',
    nombreCompleto: 'SOLES'
  },
  [DOLARES]: {
    id: [DOLARES],
    nombre: 'DÓLARES',
    signo: 'USD',
    nombreCompleto: 'DOLARES AMERICANOS'
  },
  [EUROS]: {
    id: [EUROS],
    nombre: 'EUROS',
    signo: 'EUR',
    nombreCompleto: 'EUROS'
  },
  [BIMONEDA]: {
    id: [BIMONEDA],
    nombre: 'BIMONEDA',
    signo: 'BI',
    nombreCompleto: 'BIMONEDA'
  }
}

const __array = [__dictionary[SOLES], __dictionary[DOLARES], __dictionary[EUROS]]
const __arrayAuxiliar = [__dictionaryAuxiliar[SOLES], __dictionaryAuxiliar[DOLARES], __dictionaryAuxiliar[EUROS], __dictionaryAuxiliar[BIMONEDA]]

export default Object.freeze({
  SOLES,
  DOLARES,
  EUROS,
  __dictionary,
  __array,
  __arrayAuxiliar
})
